import _ from 'lodash';
import { FC } from 'react';

type CardProps = {
  name: string;
  designation: string;
  testimonial: string;
  earnings: string;
};

const Card: FC<CardProps> = ({ name, designation, testimonial, earnings }) => {
  return (
    <div className="card">
      <div className="card-header">
        <div className="star-rating">
          {_.map(_.range(5), (n) => (
            <img key={n} src="/star.svg" alt="" />
          ))}
        </div>
      </div>
      <div className="gray-gradient-line" />
      <div className="card-body">
        <p>{testimonial}</p>
        <div className="earnings">{earnings}</div>
      </div>
      <div className="gray-gradient-line" />
      <div className="card-footer">
        <h6 className="name">
          {name} <span className="designation">({designation})</span>
        </h6>
      </div>
    </div>
  );
};

export default Card;
